unit GA.Rules;

interface

//KSS uses WebLib.ExtCtrls, XData.Web.Client, MainDataModule, JS;

type
  TGARulesUtils = class
    class function IsDonorGiftAidable(ADonorType: string; AAddressLine1: string; APostCode: string;
                                 ADonorClaimStatus: string): boolean;
    class function IsDonationGiftAidable(ADonorType: string; AAddressLine1: string; APostCode: string;
                                 ADonorClaimStatus: string; ADonationKind: string): boolean;
    class function SetDonorClaimStatus(ADonorType: string; AAddressLine1: string; APostCode: string): boolean;
    class function MinDateCheck(ADate: TDate): TDate;
  end;


implementation


class function TGARulesUtils.IsDonorGiftAidable(ADonorType: string; AAddressLine1: string; APostCode: string; ADonorClaimStatus: string): boolean;
begin
  if (ADonorType = 'Individual') and (AAddressLine1 <> '') and (APostCode <> '') and
     (ADonorClaimStatus = 'OK') then
    result := true
  else
    result := false;
end;

class function TGARulesUtils.IsDonationGiftAidable(ADonorType: string; AAddressLine1: string; APostCode: string;
                                           ADonorClaimStatus: string; ADonationKind: string): boolean;
begin
  if (ADonorType = 'Individual') and (AAddressLine1 <> '') and (APostCode <> '') and
     (ADonorClaimStatus = 'OK') and (ADonationKind = 'Donation') then
    result := true
  else
    result := false;
end;

class function TGARulesUtils.SetDonorClaimStatus(ADonorType: string; AAddressLine1: string; APostCode: string): boolean;
var
  lOk: boolean;
begin
  lOk := true;
  if ADonorType <> 'Individual' then
    lOk := false;
  if (ADonorType = 'Individual') and ((AAddressLine1 = '') or (APostCode = '')) then
    lOk := false;

  result := lOk;
end;

// Check to see if the date is above the min date - this was because
// two digit years were being add
class function TGARulesUtils.MinDateCheck(ADate: TDate): TDate;
const
  MINDATE = 29221; //'01-01-1980
begin
  if ADate < MINDATE then
    result := 0
  else
    result := ADate;
end;

end.
